// The text and value strings for the CRQ statuses
// internally for consistency we use the value strings
// however for mobile on the api, we need to send and recieve text strings.
import { MOBILE } from 'AppSrc/core/components/forms/value-dependency-constants';

const SUBMITTED = {
  text: 'Draft',
  value: '0',
};
const REQUEST_FOR_AUTHORIZATION = {
  text: 'Request For Authorization',
  value: '1',
};
const REQUEST_FOR_CHANGE = {
  text: 'Request For Change',
  value: '2',
};
const PLANNING_IN_PROGRESS = {
  text: 'Planning In Progress',
  value: '3',
};
const SCHEDULED_FOR_REVIEW = {
  text: 'Scheduled For Review',
  value: '4',
};
const SCHEDULED_FOR_APPROVAL = {
  text: 'Scheduled For Approval',
  value: '5',
};
const SCHEDULED = {
  text: 'Scheduled',
  value: '6',
};
const IMPLEMENTATION_IN_PROGRESS = {
  text: 'Implementation In Progress',
  value: '7',
};
const PENDING = {
  text: 'Pending',
  value: '8',
};
const REJECTED = {
  text: 'Rejected',
  value: '9',
};
const COMPLETED = {
  text: 'Completed',
  value: '10',
};
const CLOSED = {
  text: 'Closed',
  value: '11',
};
const CANCELLED = {
  text: 'Cancelled',
  value: '12',
};
const CIRCUIT_CHECK = {
  text: 'circuitCheck',
  value: '13',
};
const POSTPONED = {
  text: 'Postponed',
  value: '12',
};

const statusArray = [
  SUBMITTED,
  REQUEST_FOR_AUTHORIZATION,
  REQUEST_FOR_CHANGE,
  PLANNING_IN_PROGRESS,
  SCHEDULED_FOR_REVIEW,
  SCHEDULED_FOR_APPROVAL,
  SCHEDULED,
  IMPLEMENTATION_IN_PROGRESS,
  PENDING,
  REJECTED,
  COMPLETED,
  CLOSED,
  CANCELLED,
  POSTPONED,
];

const getStatusForValue = (statusValue) => statusArray.find((elem) => elem.value === statusValue);

// method to get the correct status parameter for a statusValue
// depending on network.
// use text for mobile, or value for fixed
// NOTE:
// This should not be confused with getStatusValueForParameter
const getStatusParameter = (statusValue, network) => {
  if (!statusValue || !network) { return null; }
  const status = getStatusForValue(statusValue);
  if (!status) {
    console.warn('No status found for statusValue', statusValue);
    return null;
  }
  return network === MOBILE ? status.text : status.value;
};

// hence we need Text for fixed network for related CRQ
const getStatusParameterFixed = (statusValue, network) => {
  if (!statusValue || !network) { return null; }
  const status = getStatusForValue(statusValue);
  if (!status) {
    console.warn('No status found for statusValue', statusValue);
    return null;
  }
  return network === 'fixed' ? status.text : status.value;
};

// method to get the correct status value for an api status paramter
// depending on network. For fixed the parameter represents the value
// otherwise it represents the text
// NOTE:
// This should not be confused with getStatusParameter
const getStatusValueForParameter = (statusParameter, network) => {
  if (!statusParameter || !network) { return null; }

  const status = statusArray.find((elem) => {
    const parameterMatch = network === MOBILE ? elem.text : elem.value;
    return statusParameter === parameterMatch;
  });


  if (!status) {
    console.warn('No status found for statusParameter', statusParameter);
    return null;
  }
  // we use status values internally
  return status.value;
};

// get parameter for status for the searchCrq endpoint in the correct format
const getCrqListStatusParameter = (statusId) => {
  const status = getStatusForValue(statusId);
  // status parameter for the searchCrq endpoint requires
  // status ids for fixed and mobile seperated by a comma
  // IE `<value>,<text>` or `'4,Scheduled For Review'`
  return status ? `${status.value},${status.text}` : null;
};




const CRQ_STATUSES = {
  submitted: SUBMITTED.value,
  requestForAuthorization: REQUEST_FOR_AUTHORIZATION.value, // not used
  requestForChange: REQUEST_FOR_CHANGE.value, // not used
  coordinator: PLANNING_IN_PROGRESS.value,
  peerReview: SCHEDULED_FOR_REVIEW.value,
  approvals: SCHEDULED_FOR_APPROVAL.value,
  scheduled: SCHEDULED.value,
  implementation: IMPLEMENTATION_IN_PROGRESS.value,
  pending: PENDING.value, // not used
  rejected: REJECTED.value,
  completed: COMPLETED.value,
  closed: CLOSED.value,
  cancelled: CANCELLED.value,
  circuitCheck: CIRCUIT_CHECK.value, // For cicuit check status error
  postpone: POSTPONED.value,
};

// NOTE these display values for the portal are different to text values for the statuses
const CRQ_STATUS_DISPLAY_NAMES = {
  [SUBMITTED.value]: 'Submitted',
  [PLANNING_IN_PROGRESS.value]: 'Coordinator',
  [SCHEDULED_FOR_REVIEW.value]: 'Peer Review',
  [SCHEDULED_FOR_APPROVAL.value]: 'Approvals',
  [SCHEDULED.value]: 'Scheduled',
  [IMPLEMENTATION_IN_PROGRESS.value]: 'Implementation',
  [REJECTED.value]: 'Rejected',
  [COMPLETED.value]: 'Completed',
  [CLOSED.value]: 'Closed',
  [CANCELLED.value]: 'Cancelled',
};

const ACTORS_BY_CRQ_STATUS = {
  [SUBMITTED.value]: 'requestor',
  [PLANNING_IN_PROGRESS.value]: 'coordinator',
  [SCHEDULED_FOR_REVIEW.value]: 'peer reviewer',
  [SCHEDULED_FOR_APPROVAL.value]: 'approver',
  // no idea what these actors are called
  // [SCHEDULED]: 'Scheduled',
  [IMPLEMENTATION_IN_PROGRESS]: 'Completion review',
  // [REJECTED]: 'Rejected',
  [COMPLETED]: 'Failure review',
  // [CLOSED]: 'Closed',
  // [CANCELLED]: 'Cancelled',
};

const getActorForCrqStatus = (crqStatus) => {

  const actor = ACTORS_BY_CRQ_STATUS[crqStatus];

  if (actor) {
    return actor;
  }

  console.error(`Unable to find actor for crqStatus: ${crqStatus}`);

  if (!crqStatus || crqStatus === '') {
    // fallback A: (because I hate seeing undefined/null/false or just nothing printed)
    // if it's null, undefined or an empty string, they're at least gonna be a person right?
    return 'person';
  }

  // fallback B:
  // probably more descript than person...
  return crqStatus;

};



const catchBadStatus = (status) => {

  const statusValues = statusArray.map((elem) => elem.value);

  if (!statusValues.includes(status)) {
    console.error(`Unrecognised crq status: ${status}`);
  }
};

const isStatusCoordinator = (status) => {
  catchBadStatus(status);
  return status === CRQ_STATUSES.coordinator;
};

const isStatusPeerReview = (status) => {
  catchBadStatus(status);
  return status === CRQ_STATUSES.peerReview;
};

const isStatusApprovals = (status) => {
  catchBadStatus(status);
  return status === CRQ_STATUSES.approvals;
};

const isStatusCancelled = (status) => {
  catchBadStatus(status);
  return status === CRQ_STATUSES.cancelled;
};

const isStatusScheduled = (status) => {
  catchBadStatus(status);
  return status === CRQ_STATUSES.scheduled;
};

const isStatusImplementation = (status) => {
  catchBadStatus(status);
  return status === CRQ_STATUSES.implementation;
};

const isStatusCompleted = (status) => {
  catchBadStatus(status);
  return status === CRQ_STATUSES.completed;
};

const isStatusClosed = (status) => {
  catchBadStatus(status);
  return status === CRQ_STATUSES.closed;
};

// TODO: the functions below should be replaced by functions that retrieve the correct
// status transition for reject and approve, based on current status
// https://ocasta.atlassian.net/browse/VTO-675
/*
const getNextStatus = (status) => {
  catchBadStatus(status);

  if (isStatusCoordinator(status)) {
    const nextStatus = CRQ_STATUSES.peerReview;
    catchBadStatus(nextStatus);
    return nextStatus;
  }

  if (isStatusPeerReview(status)) {
    const nextStatus = CRQ_STATUSES.approvals;
    catchBadStatus(nextStatus);
    return nextStatus;
  }

  return null;
};


const getPrevStatus = (status) => {
  catchBadStatus(status);

  if (isStatusPeerReview(status)) {
    const prevStatus = CRQ_STATUSES.coordinator;
    catchBadStatus(prevStatus);
    return prevStatus;
  }

  return null;
};

*/





export {
  CRQ_STATUSES,
  CRQ_STATUS_DISPLAY_NAMES,
  ACTORS_BY_CRQ_STATUS,
  getActorForCrqStatus,
  isStatusCoordinator,
  isStatusPeerReview,
  isStatusApprovals,
  isStatusCancelled,
  isStatusScheduled,
  isStatusImplementation,
  isStatusCompleted,
  isStatusClosed,
  getStatusParameter,
  getStatusParameterFixed,
  getStatusValueForParameter,
  getStatusForValue,
  getCrqListStatusParameter,
  // getPrevStatus,
  // getNextStatus,
};
